// Controlled tag taxonomy for the Catalog Manager editor.
//
// Mirrors `b2b-infrastructure/api/common/food_ingest/tags.py`. The editor only
// lets users pick tags from this list (the pipeline drops anything else), so
// keep these in sync by hand.
//
// TODO(tag-catalog): share a single source of truth with the Python taxonomy
// (e.g. generate this file) so the two can't drift.

/** Food-group + NOVA processing-level categories. Normally exactly one applies. */
export const CATEGORY_TAGS: string[] = [
  "NOVA1",
  "NOVA2",
  "NOVA3",
  "NOVA4",
  "alcoholic beverages",
  "baby foods",
  "baked goods",
  "beverages",
  "breakfast cereals",
  "candies and sweets",
  "cereal grains and pasta",
  "cooking and baking ingredients",
  "dairies and products",
  "dairy substitutes",
  "desserts",
  "eggs and products",
  "fats and oils",
  "food additives",
  "fried foods",
  "fruits and products",
  "legumes and products",
  "meals",
  "meat and products",
  "nuts and seeds products",
  "pickles",
  "sauces, dips, spreads, gravies",
  "seafood and products",
  "seaweeds and products",
  "snack and protein bars",
  "snacks",
  "soups",
  "spices and condiments",
  "stuffing",
  "supplement",
  "sweeteners",
  "unbranded supplement",
  "vegetables and products",
];

/** Allergen / dietary / derived flags. Several can apply. */
export const DIETARY_TAGS: string[] = [
  "vegan",
  "vegetarian",
  "contains_dairy",
  "contains_egg",
  "contains_alcohol",
  "contains_caffeine",
  "contains_fish",
  "contains_nuts",
  "contains_peanuts",
  "contains_sesame",
  "contains_soy",
  "cholesterol free",
  "sugar free",
  "no added sugar",
  "gluten free",
];

/**
 * Keto + UPF score tags. These are derived automatically by the pipeline from
 * the nutrients and NOVA level — surfaced here so the editor can display them
 * and keep them in the allowed set, but they normally shouldn't be hand-set.
 */
export const KETO_TAGS: string[] = [
  "keto_friendly",
  "keto_moderate",
  "keto_not",
];
export const UPF_TAGS: string[] = [
  "upf_none",
  "upf_low",
  "upf_moderate",
  "upf_high",
];
export const SCORE_TAGS: string[] = [...KETO_TAGS, ...UPF_TAGS];

export const ALL_TAGS: string[] = [
  ...CATEGORY_TAGS,
  ...DIETARY_TAGS,
  ...SCORE_TAGS,
];

const _BY_LOWER: Record<string, string> = {};
ALL_TAGS.forEach((t) => {
  _BY_LOWER[t.toLowerCase()] = t;
});

/** Resolve a tag to its canonical casing if it's in the taxonomy, else null. */
export const canonicalTag = (tag: string): string | null =>
  _BY_LOWER[tag.trim().toLowerCase()] ?? null;

/** Human-friendly grouping for the tag picker. */
export const TAG_GROUPS: { label: string; tags: string[] }[] = [
  { label: "Category / NOVA", tags: CATEGORY_TAGS },
  { label: "Dietary & allergen", tags: DIETARY_TAGS },
  { label: "Keto / UPF score (auto)", tags: SCORE_TAGS },
];
